const uploadContextKey = Symbol("uploadContextKey");

export { uploadContextKey };
//# sourceMappingURL=constants.mjs.map
